export const LOADER_METRIC_NINE_BOXES         =       'LOADER_METRIC_NINE_BOXES';
export const GET_METRIC_NINE_BOXES            =       'GET_METRIC_NINE_BOXES';
export const METRIC_NINE_BOXES_FALLA          =       'METRIC_NINE_BOXES_FALLA';
export const SAVE_LOADER_METRIC_NINE_BOXES    =       'SAVE_LOADER_METRIC_NINE_BOXES';
export const FORM_METRIC_NINE_BOXES_FAIL      =       'FORM_METRIC_NINE_BOXES_FAIL';

